import { useSelector } from 'react-redux';
import useSWR from 'swr';

import { getUser } from '@/redux/selectors/auth/user';
import apiRequest from '@/services/apiRequest';
import { getCoreApi } from '@/utility/getCoreApi';

export function useSoonestTripId(
  // By default we don't refetch — the soonest trip is stable for the session.
  // Pass true to opt in to standard SWR revalidation behavior.
  revalidateOnFocus = false,
  revalidateOnReconnect = false,
  revalidateIfStale = false,
): number | undefined {
  const user = useSelector(getUser);

  const { data } = useSWR(
    user?.id ? `${getCoreApi()}/bookings/soonest` : null,
    url => apiRequest<{ booking_id: number | null }>({ url }, true, true),
    { revalidateOnFocus, revalidateOnReconnect, revalidateIfStale },
  );

  return data?.data?.booking_id ?? undefined;
}
